import { render, staticRenderFns } from "./ItemHierarchyGroup.vue?vue&type=template&id=5ce1fa49&scoped=true&"
import script from "./ItemHierarchyGroup.vue?vue&type=script&lang=ts&"
export * from "./ItemHierarchyGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce1fa49",
  null
  
)

export default component.exports